// angular imports
import { Http } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
// model imports
import { MaterialListRequest } from './../../model/materials/material_list_request.model';
import { MaterialListElement } from './../../model/materials/material_list_element.model';
// manager imports
import { ModelsManager } from './../../manager/models.manager';
import { GrowlManager } from './../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';
// service imports
import { ServerMapping } from './../../service/serverMapping.service';
import {PlswaitComponent} from '../MODAL-plswait/plswait.component';

@Injectable()
export class MaterialListService {

    private searching = false;

    private materials = [];
    private bom_materials = [];

    constructor(private http:           Http,
                private modelsManager:  ModelsManager,
                private growlManager:   GrowlManager,
                private downloadManager:  DownloadManager,
                private serverMapping:  ServerMapping) {
    }

    // returns if the service is still getting the material list or not
    isSearching() {
        return this.searching;
    }

    getMaterials() {
        return this.materials;
    }

    // executes the request to the server
    searchMaterials() {
        // executes only if searching is false
        this.materials = [];
        if (this.searching === false) {
            this.searching = true;

            this.http.get(this.serverMapping.materialSearchURL +
                            '?supplier_code=' + this.modelsManager.material_list_request.supplier_code +
                            '&company_code=' + this.modelsManager.material_list_request.company_code +
                            '&language=' + this.modelsManager.material_list_request.language +
                            '&material_code=' + this.modelsManager.material_list_request.material_code).subscribe(
                (response) => {
                    // store the response
                    const data = response.json();

                    // TODO : GROWL MANAGER
                    if (this.growlManager.checkForErrorInResponse(data)) {
                        this.growlManager.showMessagesByResponse(data);
                    } else {
                        /*
                        // build the data return on the models manager
                        this.modelsManager.material_list_response = data;
                        // build the contained bean array
                        const materials: MaterialListElement[] = [];
                        let n = 0;
                        for (const element of data.contained_bean) {
                            const material = new MaterialListElement();
                            material.n = n;
                            material.material_code          = element.material_code;
                            material.material_description   = element.material_description;
                            material.division_code          = element.division_code;
                            material.division_description   = element.division_description;
                            material.bom_flag               = element.bom_flag;
                            material.dynamic_report_flag    = element.dynamic_report_flag;
                            n ++;
                            materials.push(material);
                        }*/
                        this.materials = data.contained_bean;
                    }

                    this.searching = false;
                },
                (error) => {
                    console.log('--------------------------------');
                    console.log('!!!An error has been occurred!!!');
                    console.log(error);
                    console.log('--------------------------------');
                }
            );
        }
    }

    getBomMaterials() {
        return this.bom_materials;
    }

    // executes the request to the server
    getBomExplosion() {
        // executes only if searching is false
        if (this.searching === false) {
            this.searching = true;
            this.http.get(this.serverMapping.materialBomURL +
                            '?supplier_code=' + this.modelsManager.bom_request.supplier_code +
                            '&company_code=' + this.modelsManager.bom_request.company_code +
                            '&language=' + this.modelsManager.bom_request.language +
                            '&material_code=' + this.modelsManager.bom_request.material_code +
                            '&division_code=' + this.modelsManager.bom_request.division_code).subscribe
            (
                (response) => {

                    // store the response
                    const data = response.json();

                    // TODO : GROWL MANAGER
                    if (this.growlManager.checkForErrorInResponse(data)) {
                        this.growlManager.showMessagesByResponse(data);
                    } else {
                        this.bom_materials = data.contained_bean;
                    }

                    this.searching = false;
                },
                (error) => {
                    console.log('--------------------------------');
                    console.log('!!!An error has been occurred!!!');
                    console.log(error);
                    console.log('--------------------------------');
                }
            );
        }
    }

    downloadSchedaTecnica(divisionCode, materialCode, language, supCode, materialProvision = '', plswait?: PlswaitComponent) {
      this.plswait_show(plswait);
        this.http.get(this.serverMapping.materialTechnicalSchedeURL +
            '?division_code=' + divisionCode +
            '&material_code=' + materialCode +
            '&language=' + language +
            '&supplier_code=' + supCode +
            '&material_provision=' + materialProvision).subscribe(
            (response) => {
              const data = response.json();
              if (this.growlManager.checkForErrorInResponse(data)) {
                this.growlManager.showMessagesByResponse(data);
              }else if (data.download) {
                this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
              }
              this.plswait_hide(plswait);
              console.log(data);
            },
            (error) => {
              console.log('--------------------------------');
              console.log('!!!An error has been occurred!!!');
              console.log(error);
              console.log('--------------------------------');
              this.plswait_hide(plswait);
            }
          );
    }

    downloadScalareReport(divisionCode, materialCode, language, supplierCode, companyCode, plswait?: PlswaitComponent) {
      this.plswait_show(plswait);
        this.http.get(this.serverMapping.materialScalareReportURL +
            '?division_code=' + divisionCode +
            '&material_code=' + materialCode +
            '&language=' + language +
            '&supplier_code=' + supplierCode +
            '&company_code=' + companyCode).subscribe(
            (response) => {
              const data = response.json();
              if (this.growlManager.checkForErrorInResponse(data)) {
                this.growlManager.showMessagesByResponse(data);
              }else if (data.download) {
                this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
              }
              console.log(data);
              this.plswait_hide(plswait);
            },
            (error) => {
              console.log('--------------------------------');
              console.log('!!!An error has been occurred!!!');
              console.log(error);
              console.log('--------------------------------');
              this.plswait_hide(plswait);
            }
          );
    }

    downloadScalareExcelReport(divisionCode, materialCode, language, supplierCode, companyCode, plswait?: PlswaitComponent) {
      this.plswait_show(plswait);
        this.http.get(this.serverMapping.materialScalareExcelReportURL +
            '?division_code=' + divisionCode +
            '&material_code=' + materialCode +
            '&language=' + language +
            '&supplier_code=' + supplierCode +
            '&company_code=' + companyCode).subscribe(
            (response) => {
              const data = response.json();
              if (this.growlManager.checkForErrorInResponse(data)) {
                this.growlManager.showMessagesByResponse(data);
              }else if (data.download) {
                this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
              }
              console.log(data);
              this.plswait_hide(plswait);
            },
            (error) => {
              console.log('--------------------------------');
              console.log('!!!An error has been occurred!!!');
              console.log(error);
              console.log('--------------------------------');
              this.plswait_hide(plswait);
            }
          );
    }

    downloadArchivio (divisionCode, materialCode, language, supplierCode, companyCode, plswait?: PlswaitComponent) {
      this.plswait_show(plswait);
      ///material/download?division_code=&material_code=&language=&supplier_code=&company_code=
      this.http.get(this.serverMapping.materialArchivioURL +
        '?division_code=' + divisionCode +
        '&material_code=' + materialCode +
        '&language=' + language +
        '&supplier_code=' + supplierCode +
        '&company_code=' + companyCode).subscribe(
        (response) => {
          const data = response.json();
          if (this.growlManager.checkForErrorInResponse(data)) {
            this.growlManager.showMessagesByResponse(data);
          }else if (data.download) {
            this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
          }
          console.log(data);
          this.plswait_hide(plswait);
        },
        (error) => {
          console.log('--------------------------------');
          console.log('!!!An error has been occurred!!!');
          console.log(error);
          console.log('--------------------------------');
          this.plswait_hide(plswait);
        }
      );
    }

    plswait_show (plswait: PlswaitComponent) {
      if (plswait) {
        plswait.show();
      }
    }

    plswait_hide (plswait: PlswaitComponent) {
      if (plswait) {
        plswait.hide();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/material-list/material-list.service.ts